import { RouteType } from '../types/routes'
import LoginPage from '../pages/Login'
import GuestGuard from '../components/GuestGuard'
import AuthGuard from '../components/AuthGuard'
import RootPage from '../pages/Root'
import ResetPasswordPage from '../pages/ResetPassword'

import { routesPath } from './index'

const publicRoutes: RouteType = {
  path: '',
  component: null,
  children: [
    {
      path: routesPath.reset,
      name: 'Reset',
      component: ResetPasswordPage,
    },
    {
      path: routesPath.changePassword,
      name: 'changePassword',
      component: ResetPasswordPage,
    },
  ],
}

const guestRoutes: RouteType = {
  path: '',
  component: null,
  guard: GuestGuard,
  children: [
    {
      path: routesPath.login,
      name: 'Login',
      component: LoginPage,
    },
  ],
}

const privateRoutes: RouteType = {
  path: '',
  component: null,
  guard: AuthGuard,
  children: [
    {
      path: routesPath.root,
      name: 'Root',
      component: RootPage,
    },
  ],
}

export const defaultLayoutRoutes = [publicRoutes, guestRoutes, privateRoutes]
